<template>
    <MediaGallery
        :value="value"
        :full-width="fullWidth"
        :vertical="vertical"
        @expand="expanded = true"
        :has-another-view-open="expanded"
        :expand-enabled="expandEnabled"
        :class="mediaGalleryClass"
    >
        <template v-for="(index, name) in $slots" v-slot:[name]="data">
            <slot v-bind="data" :name="name"></slot>
        </template>
    </MediaGallery>

    <modal-component
        v-if="expandEnabled"
        v-model="expanded"
        :content-class="$style['gallery-modal-view']"
    >
        <MediaGallery
            :value="value"
            disable-expand
            full-width
            show-arrows
            :enable-arrow-keys="expanded"
            @close="expanded = false"
        ></MediaGallery>
    </modal-component>
</template>

<style module>
.gallery-modal-view {
    width: 940px;
    border-radius: 10px;
}
</style>

<script setup lang="ts">
import { ref, type PropType } from "vue";
import { hasTouch } from "../../../../shared/device/has-touch";
import MediaGallery from "./media-gallery.vue";
import ModalComponent from "../../header/appearance-containers/modal/modal.vue";
import { type MediaItem } from "./types";

const props = defineProps({
    value: {
        type: Array as PropType<MediaItem[]>,
        required: true,
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    vertical: {
        type: Boolean,
        default: false,
    },
    mediaGalleryClass: {
        type: [String, Object, Array],
    },
});

const expandEnabled = ref(!hasTouch());
const expanded = ref(false);
</script>
